<template>
<div>
  <b-button v-b-modal.add-columns variant="success" size="sm"><span><v-icon name="plus"></v-icon></span> Add Columns</b-button>
  <b-modal ref="modal" id="add-columns" hide-footer centered title="Add New Columns">
    <b-form @submit.prevent="uploadData">
      <b-form-group label="Titles:">
        <b-form-textarea
          @keydown.tab.prevent="addTabDelimiter"
          @keydown.enter.prevent="addNewlineDelimiter"
          autofocus=""
          v-model.trim="$v.input.$model"
          :class="{ 'is-invalid': $v.input.$error }"
          :disabled="inProgress"
        />
        <b-form-invalid-feedback>The field can't be empty</b-form-invalid-feedback>
      </b-form-group>
      <div class="types">
        <transition name="slideY">
          <div v-if="typeListShown" class="types-list">
            <div class="types-item" v-for="(item, index) in controls" :key="index">
              <span><v-icon :name="item.icon"></v-icon></span>
            <span>{{ item.text }}</span>
            </div>
          </div>
        </transition>
      </div>
      <div>
        <b-button @click="typeListShown=!typeListShown" variant="outline-primary">
          <span v-if="!typeListShown">Show</span><span v-if="typeListShown">Hide</span> types
        </b-button>
        <b-button type="submit" variant="primary" :disabled="inProgress">
          <span>Create</span>
        </b-button>
      </div>
    </b-form>
  </b-modal>
    <b-modal centered ref="failedModal">
      <h3 class="h2 text-center">The following rows have failed:</h3>
      <b-table-lite :items='failed' >
      </b-table-lite>
    </b-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { required } from 'vuelidate/lib/validators'
import { validationMixin } from 'vuelidate'
import eventBus from '@/helpers/event-bus'
// services
import db from '@/services/db'
import Icon from 'vue-awesome/components/Icon'
export default {
  mixins: [validationMixin],
  components: {
    'v-icon': Icon,
  },
  props: {
    controls: Array
  },
  data(){
    return {
      input: null,
      inProgress: false,
      typeListShown: false,
      failed: []
    }
  },
  computed: {
    ...mapState([
      'dataGrid_options',
    ]),
    availableGrids () {
      const grids = []

      for (let gridId in this.dataGrid_options) {
        grids.push(gridId)
      }

      return grids
    },
    availableTypes() {
      const types = []
      this.controls.forEach(obj => types.push(obj.type))
      return types
    }
  },
  methods: {
    addTabDelimiter(){
      this.input = event.target.value + '\t'
    },
    addNewlineDelimiter(){
      this.input = event.target.value + '\n'
    },
    showModal(){
      if(this.$refs.modal) this.$refs.modal.show()
    },
    hideModal(){
      if(this.$refs.modal) this.$refs.modal.hide()
    },
    diassembleInput(input){
      let array = [],
          re = /\n/,
          r = input.split(re)
      re = /\t|\s\s|\s\s\s\s/
      r.forEach(line => {
        let _arr = line.split(re),
            [id, ...cols] = _arr,
            // TODO: static data shouldn't be used here
            names = ['displayName', 'type', 'lookUpTable'],
            cells = {},
            obj = {}
        // TODO: think about the way input is processed
        names.forEach((key, i) => cells[key] = cols[i])
        obj[id] = cells
        array.push(obj)        
      })
      return array
    },
    async uploadData(){
      this.failed = []
      let array = this.diassembleInput(this.input)
      // check the available grids and reduce the obj to exclude the non-available ones
      let cleanArray = array.filter(obj => this.availableGrids.includes(Object.keys(obj)[0]))
      // compose data 
      for(let obj of cleanArray){
        let key = Object.keys(obj)[0],
            existing = []
      //  collecting the existing data
        Object.values(this.dataGrid_options[key].meta).forEach(obj => existing.push(obj.displayName))
      // checking for duplicates and wrong types
        let conditions = !existing.includes(obj[key].displayName) &&
                         this.availableTypes.includes(obj[key].type),
            data 
        if(conditions) { 
          data = {
            type: obj[key].type,
            gridId: key,
            displayName: obj[key].displayName,
            propertyName: this.$sanitize(obj[key].displayName),
            lookUpTable: obj[key].lookUpTable
          }
        } else {
          let badInput = {table:key, displayName:obj[key].displayName, type:obj[key].type}
          this.failed.push(badInput)
          console.log(`Some of the provided values for ${key} either have duplicates or of invalide type`)
        }
        if(data) {
          await db.dataGrid.data.addColumn(data)
          this.$emit('submitted')
        }
      }
      this.hideModal()
      this.$nextTick(
        function(){
          if(this.failed.length !== 0) this.$refs.failedModal.show()
        }
      )
    },
  },
  validations: {
    input: {
      required,
    },
  },
}
</script>

<style lang="scss" scoped>
.types{
  column-count: 3;
  margin: 1em 0;
  overflow: hidden;
  z-index: 1100;
}
.types-item{
  font-size: .8em;
  margin: .5em 0;
  
}
.slideY-enter-active, .slideY-leave-active{
  transition: opacity .25s, transform .25s;
}
.slideY-enter, .slideY-leave-to{
  -webkit-transform: scaleY(0);
  transform: scaleY(0);
  transform-origin: top;
  opacity: 0;
}
.slideY-enter-to, .slideY-leave{
  -webkit-transform: scaleY(1);
  transform: scaleY(1);
  transform-origin: top;
  opacity: 1;
}
.failed-list{
  display: flex;
  justify-content: space-between;
  padding: 1em 2.5em;
}
</style>

